import type { CodeParams, CodeParamsView } from "@whilecat/core/tasks/common/params/code-task-params.ts";
import { getRandomElement } from "@whilecat/core/utils/arrays.js";
import { isPresent } from "@whilecat/core/utils/objects.js";
import { isNotBlankArray } from "@whilecat/core/utils/string.js";
import type { CodeRunResult } from "@whilecat/services/java-compiler-service.js";

type AnswerSupplier = () => string;
type AnswerVerifier = (output: CodeRunResult) => boolean;

export type CodeEditorParams = CodeParams & {
    correctAnswer: Array<string>;
    correctAnswerRegExp?: RegExp | undefined;
    correctAnswerSupplier?: AnswerSupplier | undefined;
    correctAnswerVerifier?: AnswerVerifier | undefined;
    _FIXME_TASK_WITHOUT_SUPPLIER?: boolean | undefined;
};

export class CodeEditorParamsView implements CodeParamsView {
    private data: CodeEditorParams;

    constructor(data: CodeEditorParams) {
        this.data = data;
    }

    isEditable(): boolean {
        return this.data.editable;
    }

    isExampleTask(): boolean {
        return this.data.exampleTask;
    }

    isCorrectOutputPredefined(): boolean {
        const supplierPredefined = isPresent(this.data.correctAnswerSupplier);

        const correctAnswerPredefined = this.data.correctAnswer.length > 0 && isNotBlankArray(this.data.correctAnswer);

        return supplierPredefined || correctAnswerPredefined;
    }

    getCorrectCode(): string {
        return this.data.correctCode;
    }

    getPredefinedResult(): CodeRunResult {
        const output = isPresent(this.data.correctAnswerSupplier)
            ? this.data.correctAnswerSupplier!()
            : getRandomElement(this.data.correctAnswer);

        return {
            output: output,
            result: "SUCCESS", // FIXME: could be not really a success, some example tasks could have ERROR actually
        } as CodeRunResult;
    }
}
